/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import DocumentsAction from './DocumentsAction/index'
import ImagesAction from './ImagesAction/index'
import LedgerAction from './LedgerAction/index'
import MedicalHistoryAction from './MedicalHistoryAction/index'
import NotesAction from './NotesAction/index'
import ProfileAction from './ProfileAction/index'
import React from 'react'
import TreatmentAction from './TreatmentAction/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Search/Content/Profiles/Content/Profile/ProfileActions/Content"
  
}) {
  return (<React.Fragment
>
<ProfileAction
  viewPath={`${viewPath}/ProfileAction`}
/>
<MedicalHistoryAction
  viewPath={`${viewPath}/MedicalHistoryAction`}
/>
<TreatmentAction
  viewPath={`${viewPath}/TreatmentAction`}
/>
<LedgerAction
  viewPath={`${viewPath}/LedgerAction`}
/>
<ImagesAction
  viewPath={`${viewPath}/ImagesAction`}
/>
<DocumentsAction
  viewPath={`${viewPath}/DocumentsAction`}
/>
<NotesAction
  viewPath={`${viewPath}/NotesAction`}
/>
{children}
</React.Fragment>)
}